
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SystemModule from "@/store/modules/system";
import { getModule } from "vuex-module-decorators";
import { GroupListResource } from "../../models/api/system/groups";
import notifications from "../../lib/notifications";

const systemModuleState = getModule(SystemModule);

interface DefaultField {
  key: string;
  label: string;
}

@Component
export default class Groups extends Vue {
  loading: boolean = true;
  groups: GroupListResource[] = [];
  fields: DefaultField[] = [
    {
      key: "name",
      label: "Name"
    },
    {
      key: "roleName",
      label: "Role"
    },
    {
      key: "actions",
      label: ""
    }
  ];

  async created() {
    try {
      this.groups = await systemModuleState.getGroups();
    } catch (ex) {
      notifications.error("Groups", "Failed to load groups", ex);
    }
    this.loading = false;
  }
}
